import React, { useEffect, useState } from 'react';
import TrainingService from '../../Service/TrainingService';
import image_croix from "../Pages/image/croix.png";
import BlogService from '../../Service/BlogService';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ImagePlaceholder from './ImagePlaceholder';
import MyLoader from './Loader';

const ArticleViewer = ({ article, loading }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [editMode, setEditMode] = useState(false);
    const [textAreaValue, setTextAreaValue] = useState('');
    const token = sessionStorage.getItem('token');
    let formattedDate
    if (!loading) {
        formattedDate = new Date(article.date).toLocaleDateString('fr-FR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    }

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (article && article.content) {
            setTextAreaValue(article.content);
        }
    }, [article]);

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % article.images.length);
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + article.images.length) % article.images.length);
    };

    const handleEditClick = () => {
        setEditMode(true);
    };

    const handleInputChange = (event) => {
        setTextAreaValue(event.target.value);
    };

    const handleSaveClick = async () => {
        article.content = textAreaValue;

        try {
            const response = await BlogService.putArticle(article.id, article.title, article.content, article.date);
            console.log(response);
        } catch (error) {
            console.error("Error saving content:", error);
        }
        setEditMode(false);
    };

    const handleDeleteClick = async () => {
        try {
            await BlogService.deleteArticle(article.id);
            console.log("Article deleted successfully");
            navigate("/blog")
        } catch (error) {
            console.error("Error deleting article:", error);
        }
    };

    const getLinesWithIcons = (text) => {
        return text.split(/\n/).map((line, index) => (
            line.trim().startsWith('-') ? (
                <div className="line" key={index}>
                    <img src={image_croix} alt="Bullet icon" className="section-icon" />
                    <span>{line.trim().substring(1).trim()}</span>
                </div>
            ) : (
                <div className="line" key={index}>
                    <span>{line.trim()}</span>
                </div>
            )
        ));
    };

    return (
        <div className="article-view-container">
            <div className="slider-container">
                <div className="image-wrapper">
                    {loading ? (
                        ImagePlaceholder()
                    ) : (
                        article.images.length > 0 && (
                            <img
                                src={`https://backsc.osc-fr1.scalingo.io${article.images[currentIndex]}`}
                                alt={`Slide ${currentIndex}`}
                                className="image"
                            />
                        )
                    )}
                </div>
                <div className="nav-buttons">
                    <button onClick={prevSlide} className="nav-button" aria-label="Previous slide">❮</button>
                    <button onClick={nextSlide} className="nav-button" aria-label="Next slide">❯</button>
                </div>
            </div>
            {loading ? (
                MyLoader()
            ) : (
                <div className="description-container">
                    <h2>{article.title || "No Title Available"}</h2>
                    <p className="article-date">{formattedDate || "No Date Available"}</p>

                    {editMode ? (
                        <textarea
                            value={textAreaValue}
                            onChange={handleInputChange}
                            rows={10}
                            style={{ width: '100%' }}
                        />
                    ) : (
                        <div style={{ whiteSpace: 'pre-wrap' }}>
                            {getLinesWithIcons(textAreaValue)}
                        </div>
                    )}

                    {editMode ? (
                        <button
                            className="inscription-button modif_button"
                            onClick={handleSaveClick}
                            style={{ right: 0 }}
                        >
                            Enregistrer
                        </button>
                    ) : (
                        token === '' && (
                            <button
                                className="inscription-button modif_button"
                                onClick={handleEditClick}
                                style={{ marginLeft: '10px' }}
                            >
                                Modifier
                            </button>
                        )
                    )}
                    {/* Delete button */}
                    {token === '' && (
                        <button
                            className="inscription-button delete_button"
                            onClick={handleDeleteClick}
                            style={{ marginLeft: '10px', backgroundColor: 'red', color: 'white' }}
                        >
                            Supprimer
                        </button>
                    )}
                </div>
            )}

        </div>
    );
};

export default ArticleViewer;
